import { createActionTypes } from 'utils/action/actionTypes';

export const UPDATE_PROFILE = createActionTypes('UPDATE_PROFILE');
export const GET_PROFILE = createActionTypes('GET_PROFILE');
export const FETCH_PROFILE = createActionTypes('FETCH_PROFILE');
